/** A polygon vertex as returned/accepted by the API (object form). */
export interface GeoZoneLatLng {
  lat: number;
  lng: number;
}

/** Geo-zone status: `1` = active, `0` = inactive. */
export const GEO_ZONE_STATUS = {
  INACTIVE: 0,
  ACTIVE: 1,
} as const;

export type GeoZoneStatus = (typeof GEO_ZONE_STATUS)[keyof typeof GEO_ZONE_STATUS];

/** List item as returned by `/geo-zone/index` (no polygon geometry). */
export interface GeoZoneBase {
  id: number;
  name: string;
  status: GeoZoneStatus;
  created_at: string;
}

export interface GeoZoneCourier {
  id: number;
  full_name: string;
}

/** Full resource as returned by `/geo-zone/show`. */
export interface GeoZoneById extends GeoZoneBase {
  polygon: GeoZoneLatLng[];
  updated_at?: string;
  type?: number;
  couriers?: GeoZoneCourier[];
}

export interface GeoZoneCreatePayload {
  name: string;
  polygon: GeoZoneLatLng[];
  status: GeoZoneStatus;
}

export interface GeoZoneUpdatePayload extends GeoZoneCreatePayload {
  id: number;
}

/** Item as returned by `/geo-zone/polygon-list` (all saved zones with geometry). */
export interface GeoZonePolygonListItem {
  id: number;
  name: string;
  polygon: GeoZoneLatLng[];
}

/** Lightweight option used by async selects. */
export interface GeoZoneItem {
  id: number;
  name: string;
}

export interface GeoZoneItemListParams {
  ids?: number[];
  name?: string;
}
